import UserName from "../../component/Username";

const CreateUsername = () => {
  return (
    <>
      <UserName />
    </>
  );
};
export default CreateUsername;
